var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contractPage"},[_vm._m(0),_c('div',{staticClass:"content-page",domProps:{"innerHTML":_vm._s(_vm.pageData)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v("隐私政策")])])
}]

export { render, staticRenderFns }